<template>
    <div class="swiper">
        <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="gravure_item in gravure_list">
                <a :href="getItemUrl(gravure_item)">
                    <div class="c-slider-normal__img">
                        <webp-picture :webp="gravure_item.thumbnail_webp" class="inherit">
                            <img :src="gravure_item.thumbnail" :alt="gravure_item.title" loading="lazy">
                        </webp-picture>
                    </div>
                    <div class="label-container">
                        <div class="c-label is-new" v-if="gravure_item.is_new">New</div>
                        <div class="c-label is-photos">{{ gravure_item.category }}</div>
                        <div class="c-label is-up" v-if="gravure_item.is_pre_order == true">予約受付中</div>
                        <div class="c-label is-limited" v-if="gravure_item.extra">限定特典付</div>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-booktitle u-text-ellipsis has-2-lines">{{ gravure_item.title }}</p>
                    </div>
                    <div class="c-book-block__wrapper">
                        <p class="c-bookname u-text-ellipsis has-2-lines">{{ gravure_item.model_name }}</p>
                    </div>
                </a>
                <div v-if="gravure_item.isReserveFlag" class="c-round-btn is-disabled">
                    <a class="is-blue" style="color: white;">予約済み</a>
                </div>
                <div v-else-if="gravure_item.hasSubscribe" class="c-round-btn is-disabled">
                    <a class="is-blue" style="color: white;">定期購読中</a>
                </div>
                <div v-else class="c-round-btn is-positive">
                    <a class="is-blue" style="color: white;" :href="getPreOrderUrl(gravure_item)" target="_blank">予約をする</a>
                </div>
            </div>

        </div>
        <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
export default {
    props:[
        'gravure_list',
        'route_list',
        'utm_content'
    ],
    mixins: [routeMixin],
    data(){
    return{
    }
    },
    methods: {
        getItemUrl: function(item) {
            let route_name = 'site.item.detail.gravure';
            if(item.category_cd === "WPB") {
                route_name = 'site.weeklyplayboy';
            }
            return this.route(this.route_list, route_name, {
                item_detail_url:item.url,
            })
        },
        getPreOrderUrl: function(item) {
            let route_name = 'site.item.pre_order.new';
            if(item.category_cd === "WPB") {
                route_name = 'site.item.pre_order.new_weekly';
            }
            return this.route(this.route_list, route_name, {
                item_detail_url:item.url,
            })
        }
    },
}
</script>

<style scoped>
.swiper {
    width: 100%;
}

.label-container {
    min-height: 42px;
    display: flex;
    flex-wrap: wrap;
}

.c-booktitle {
    margin: 0;
    color: var(--gj-text-color-light);
    text-align: start;
    word-break: break-all;
}

.c-bookname {
    margin: 0;
    text-align: start;
    align-items: center;
    line-height: 18.2px;
}

.c-book-block__wrapper {
    display: flex;
    align-items: center;
    &:has(.c-booktitle) {
        min-height: 32px;
    }
    &:has(.c-bookname) {
        min-height: 37px;
        margin-bottom: 8px;
    }
}
</style>
